import { z } from 'zod';

export const GroupClassToolName = 'groupClass';

/**
 * Group class tool arguments schema
 */
export const groupClassToolArgsSchema = z.object({
  query: z
    .string()
    .describe(
      'User query about group classes, schedules, reservations, or class information.',
    ),
});

export type GroupClassToolArgs = z.infer<typeof groupClassToolArgsSchema>;
